module.exports = __webpack_public_path__ + "media/images/icons/outlined/ellipsis-a8a05a103d8759f5dae3ad1cd5f45404.svg";